import React, {
  ReactNode,
  createContext,
  useState,
  useContext,
  SetStateAction,
  Dispatch,
} from 'react';

const TableProgressContext = createContext<[number, Dispatch<SetStateAction<number>>] | undefined>(
  undefined
);

interface State {
  rowIndex: number;
}

/**
 * TableProgressProvider - Tracks table row progress
 *
 * Simplified version that just provides progress state management.
 * Location state integration can be added per-component as needed.
 */
const TableProgressProvider = ({ children }: { children: ReactNode }) => {
  const [progress, setProgress] = useState(0);

  return (
    <TableProgressContext.Provider value={[progress, setProgress]}>
      {children}
    </TableProgressContext.Provider>
  );
};

/**
 * Saves the row index of the last visited dashboard
 */
function useTableProgress() {
  const context = useContext(TableProgressContext);
  if (context === undefined) {
    throw new Error('useTableProgress must be used within a TableProgressProvider');
  }
  return context;
}

export { TableProgressProvider, useTableProgress };
